import { KeyDateInfo } from "QuorumGrassroots/campaign-forms/components/GotvV2Form/components/CollapsibleKeyDatesSection/CollapsibleKeyDatesSection.types"

export const LAST_DAY_TO_REGISTER_DATES: KeyDateInfo[] = [
    {
        date: "Mon Oct 21, 2024",
        description: "Postmarked",
        url: "https://www.example.com",
    },
    {
        date: "Sat Oct 26, 2024",
        description: "In-person, received",
        url: "https://www.example.com",
    },
    {
        date: "Sat Oct 26, 2024",
        description: "Post received",
        url: "https://www.example.com",
    },
]

export const REQUEST_AN_ABSENTEE_BALLOT_DATES: KeyDateInfo[] = [
    {
        date: "Sat Oct 26, 2024",
        description: "Online",
        url: "https://www.example.com",
    },
    {
        date: "Sat Oct 26, 2024",
        description: "In-person, received",
        url: "https://www.example.com",
    },
    {
        date: "Mon Nov 4, 2024",
        description: "In-person request",
        url: "https://www.example.com",
    },
]

export const EARLY_VOTING_DATES: KeyDateInfo[] = [
    {
        date: "Sat Oct 26, 2024",
        description: "Online",
        url: "https://www.example.com",
    },
    {
        date: "Sat Oct 26, 2024",
        description: "In-person, received",
        url: "https://www.example.com",
    },
    {
        date: "Mon Nov 4, 2024",
        description: "In-person request",
        url: "https://www.example.com",
    },
]
